"use client";

import { Box } from "@ecco/ui/box";
import { Text } from "@ecco/ui/text";
import { useId } from "react";
import { styles } from "./TransparentScreenLock.styles";
import { EccoPaymentLoading } from "@components/ui/ecco-loading/EccoPaymentLoading";

interface TransparentScreenLockProps {
    header: string;
    message: string;
}

export function TransparentScreenLock({ header, message }: TransparentScreenLockProps) {
    const headerId = useId();
    const messageId = useId();
    return (
        <Box
            sx={styles.screenLock}
            role="dialog"
            aria-modal="true"
            aria-busy="true"
            aria-labelledby={headerId}
            aria-describedby={messageId}
            data-testid="payment-screen-lock"
        >
            <EccoPaymentLoading />
            <Box sx={styles.textWrapper}>
                <Text id={headerId} size="b2" sx={styles.header}>
                    {header}
                </Text>
                <Text id={messageId} size="b3" sx={styles.subText}>
                    {message}
                </Text>
            </Box>
        </Box>
    );
}
